import GeneratedRoomStore from "./generated/GeneratedRoomStore"

class RoomStore extends GeneratedRoomStore {

}

export const roomStore = new RoomStore()
